import { useSelector } from "react-redux";

// [CANA-891] Reports v2 is limited to the Drakkar organisation. The name comes
// from /me/ (me.info.organization.name); child organisations have their own
// names, so their users do not match.
export default function useIsDrakkarOrg() {
  const name = useSelector((state) => state?.me?.info?.organization?.name);
  return typeof name === "string" && name.trim().toLowerCase() === "drakkar";
}
